// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__hYEWf","img":"style_img__8TzRF","carouselControlNext":"style_carouselControlNext__CWmm6"};